import React from 'react';
import Hdr from './shared/Hdr';
import { useState, useEffect } from 'react';
import swal from 'sweetalert';
import { apiPath } from "../src/services/apiConfig";

function HealthcardUser() {
  const user = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  const usrRole = localStorage.getItem('user-role');
  //  const [displayApplicant, setDisplayApplicant] = useState('none');
  const [displayUpdApplicant, setDisplayUpdApplicant] = useState('none');
  const [data, setData] = useState([]);
  const [dataStat, setDataStat] = useState();
  const [ApplicantName, setApplicantName] = useState('');
  const [ApplicantAddress1, setApplicantAddress1] = useState('');
  const [ApplicantAddress2, setApplicantAddress2] = useState('');
  const [ApplicantCity, setApplicantCity] = useState('');
  const [ApplicantDistrict, setApplicantDistrict] = useState('');
  const [ApplicantPin, setApplicantPin] = useState('');
  // const [uid, setUID] = useState('');
  // const [specialityType, setSpecialityType] = useState('1');
  const [verfied, setVerfied] = useState(true);
  const [updApplicantOrg, setApplicantUpdOrg] = useState('')
  const [updApplicantName, setApplicantUpdName] = useState('');
  const [updApplicantAddress1, setApplicantUpdAddress1] = useState('');
  const [updApplicantAddress2, setApplicantUpdaddress2] = useState('');
  const [updApplicantCity, setApplicantUpdCity] = useState('');
  const [updApplicantDistrict, setApplicantUpdDistrict] = useState('');
  const [updApplicantPin, setApplicantUpdPin] = useState('');
  const [id, setID] = useState('');
  // const [uidErr, setUIDErr] = useState('');
  // const [Err, SetErr] = useState([]);



  const [updApplicantGender, setApplicantUpdGender] = useState('')
  const [updApplicantAge, setApplicantUpdAge] = useState('')
  const [updApplicantMobile, setApplicantUpdMobile] = useState('')
  const [updApplicantAdhar, setApplicantUpdAdhar] = useState('')

  let txt = "";


  useEffect(() => {
    getApplicant()
  }, [])

  {/*
  function openApplicant() {
    setDisplayApplicant('block')
  }

  function closeApplicant() {
    setDisplayApplicant('none')
  }
*/}

  function openUpdApplicant() {
    setDisplayUpdApplicant('block')
  }

  function closeUpdUser() {
    setDisplayUpdApplicant('none')
  }

  async function updateApplicant(id) {

    let result = await fetch(apiPath + "updateApplicant", {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "id": id,
        "org_name": updApplicantOrg,
        "name": updApplicantName,
        "gender": updApplicantGender,
        "age": updApplicantAge,
        "mobile": updApplicantMobile,
        "aadhar": updApplicantAdhar,
        "address_1": updApplicantAddress1,
        "address_2": updApplicantAddress2,
        "city": updApplicantCity,
        "district": updApplicantDistrict,
        "pin": updApplicantPin
      })
    });
    result = await result.json();

    showSwal(result.success, result.message)

    getApplicant()
  }

  async function deleteApplicant(id) {

    let result = await fetch(apiPath + "deleteApplicant/" + id, {
      method: 'DELETE',
      headers: {
        "Authorization": `Bearer ${token}`
      },
    });
    result = await result.json();

    showSwal(result.success, result.message)

    getApplicant()
  }


  async function updateOperation(id) {

    let result = await fetch(apiPath + "applicant/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    console.warn(result.data)

    setApplicantUpdOrg(result.data[0].org_name);
    setApplicantUpdName(result.data[0].applicant);
    setApplicantUpdGender(result.data[0].gender);
    setApplicantUpdAge(result.data[0].age);
    setApplicantUpdMobile(result.data[0].mobile);
    setApplicantUpdAdhar(result.data[0].aadhar);
    setApplicantUpdAddress1(result.data[0].address_1)
    setApplicantUpdaddress2(result.data[0].address_2)
    setApplicantUpdCity(result.data[0].city)
    setApplicantUpdDistrict(result.data[0].district)
    setApplicantUpdPin(result.data[0].pin)
    setID(result.data[0].id)

    openUpdApplicant();

  }

  function deleteOperation(id) {
    //alert(id)
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          deleteApplicant(id);
        }
        else {
          swal("Your record is safe!");
        }
      });
  }


  //* LIST OF ALL Applicant (for initial screen)*/ 

  async function getApplicant() {
    let result = await fetch(apiPath + "applicants",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })
    result = await result.json();

    console.log(result.data)

    setDataStat(result.success);
    setData(result.data);

    if (result.success === true) {
      setData(result.data);
    } else { setData([]) }
  }

  {/*
  function uidHandler(e) {
    setUIDErr('');
    e.preventDefault()
    let item = e.target.value
    if (!item) {
      setUIDErr("required")
    } else {
      setUID(item)
    }
  }
 */}

  function verifyApplicant() {
    setVerfied(true)
    addApplicant()
  }

  {/*ADD A NEW Applicant*/ }
  async function addApplicant() {
    //    alert('Add,'+ApplicantName)
    if (verfied) {

      let result = await fetch(apiPath + "storeOrg", {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "name": ApplicantName,
          "address_1": ApplicantAddress1,
          "address_2": ApplicantAddress2,
          "city": ApplicantCity,
          "district": ApplicantDistrict,
          "pin": ApplicantPin
        })
      });
      result = await result.json();
      //  console.warn(result)

      //      if (result.success) { }
      //      else {
      //        SetErr(result.data);
      //      }

      showSwal(result.success, result.message)
      getApplicant()
    }
  }


  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success!",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }


  return (

    <div style={{ 'height': '90vh' }}>
      <Hdr />
      <div className="row p16">
        <div className="c12-l-8">
          <h3 className="" >ADS Hospital - User : {user} </h3>
        </div>
        <div className="c12-l-4 pr32 ">
          <p className="medium right">User : ({usrRole})</p>
        </div>
      </div>

      <div className="row p16" style={{ 'height': '90%' }}>
        <div className=" c12-l-12 cont__content p4" style={{ 'height': '100%' }}>
          <div className="row p32">
            <div className="c12-l-3">
              <h4 className="wide">Health Card User</h4>
            </div>
            {/*
            <div className="c12-l-7"></div>
            <div className="c12-l-2">
              <button onClick={openApplicant} type="button" name="button"
                className="btn solid round">Create Applicant</button>
            </div>
            */}
          </div>

          <div className="row mt16" >

            <table style={{ 'height': '100%', 'width': '100%', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
              <thead>
                <tr>
                  <th className="th-border center" width="3%">Id</th>
                  <th className="th-border left" width="15%">Org</th>
                  <th className="th-border left" width="15%">Applicant</th>
                  <th className="th-border left" width="2%">Gender</th>
                  <th className="th-border left" width="3%">Age</th>
                  <th className="th-border left" width="8%">Mobile</th>
                  <th className="th-border left" width="8%">Adhar</th>
                  <th className="th-border left" width="15%">Address1</th>
                  <th className="th-border left" width="15%">Address2</th>
                  <th className="th-border left" width="8%">City</th>
                  <th className="th-border left" width="15%">District</th>
                  <th className="th-border left" width="10%">Pin</th>
                  <th className="th-border left" width="3%">Edit</th>
                  <th className="th-border left" width="3%">Delete</th>
                </tr>
              </thead>
              <tbody >
                {
                  (dataStat === true ?
                    (
                      data.map((item, index) =>
                        <tr className="tr-border" key={index}>
                          <td className="center">{item.id}</td>
                          <td className="left">{item.org_name}</td>
                          <td className="left">{item.applicant}</td>
                          <td className="left">{item.gender}</td>
                          <td className="left">{item.age}</td>
                          <td className="left">{item.mobile}</td>
                          <td className="left">{item.aadhar}</td>
                          <td className="left">{item.address_1}</td>
                          <td className="left">{item.address_2}</td>
                          <td className="left">{item.city}</td>
                          <td className="left">{item.district}</td>
                          <td className="left">{item.pin}</td>
                          <td onClick={() => { updateOperation(item.id) }} className="center"><img src={require('./asset/images/adm_edit.png')} alt="" /></td>
                          <td onClick={() => { deleteOperation(item.id) }} className="center"><img src={require('./asset/images/adm_del.png')} alt="" /></td>
                        </tr>
                      ))
                    : <tr><td>No data</td></tr>)
                }
              </tbody>
            </table>
          </div>

          {/* SCREEN FROM UPDTAE EXISTING USER */}

          <div id="newdept" style={{ 'display': displayUpdApplicant }} className="cont__new-deptDetails">
            <form className="" action="" method="">
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeUpdUser}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Edit Applicant</h2><br />

                  <input type="hidden" value={id} />
                  <div className="c12-l-12">
                    <div className="row">
                      <div className="c12-l-1"></div>

                      <div className='c12-l-5'>

                        <p style={{ 'fontSize': '0.65rem' }}>Organisation Name</p>
                        <input type="text" className="box small" autoComplete="off"
                          placeholder="Organisation Name" onChange={(e) => setApplicantUpdOrg(e.target.value)}
                          value={updApplicantOrg} />

                        <p style={{ 'fontSize': '0.65rem' }}>Applicant Name</p>
                        <input type="text" className="box small" autoComplete="off"
                          placeholder="Name of the Applicant" onChange={(e) => setApplicantUpdName(e.target.value)}
                          value={updApplicantName} />

                        <p style={{ 'fontSize': '0.65rem' }}>Gender</p>
                        <input type="text" className="box small" autoComplete="off"
                          placeholder="Gender (M/F)" onChange={(e) => setApplicantUpdGender(e.target.value)}
                          value={updApplicantGender} />

                        <p style={{ 'fontSize': '0.65rem' }}>Age</p>
                        <input type="text" className="box small" autoComplete="off"
                          placeholder="Age" onChange={(e) => setApplicantUpdAge(e.target.value)}
                          value={updApplicantAge} />

                        <p style={{ 'fontSize': '0.65rem' }}>Mobile</p>
                        <input type="text" className="box small" autoComplete="off"
                          placeholder="Mobile" onChange={(e) => setApplicantUpdMobile(e.target.value)}
                          value={updApplicantMobile} />

                        <p style={{ 'fontSize': '0.65rem' }}>Adhar</p>
                        <input type="text" className="box small" autoComplete="off"
                          placeholder="Adhar" onChange={(e) => setApplicantUpdAdhar(e.target.value)}
                          value={updApplicantAdhar} />
                      </div>

                      <div className="c12-l-1"></div>

                      <div className='c12-l-5'>

                        <p style={{ 'fontSize': '0.65rem' }}>Address1</p>
                        <input type="text" className="box small" autoComplete="off"
                          placeholder="Address Line 1" onChange={(e) => setApplicantUpdAddress1(e.target.value)}
                          value={updApplicantAddress1} />

                        <p style={{ 'fontSize': '0.65rem' }}>Address2</p>
                        <input style={{ 'resize': 'none' }} type="text" className="box small" autoComplete="off"
                          placeholder="Address Line 2" onChange={(e) => setApplicantUpdaddress2(e.target.value)}
                          value={updApplicantAddress2} />

                        <p style={{ 'fontSize': '0.65rem' }}>City/Town</p>
                        <input style={{ 'resize': 'none' }} type="text" className="box small" autoComplete="off"
                          placeholder="City/Town" onChange={(e) => setApplicantUpdCity(e.target.value)}
                          value={updApplicantCity} />

                        <p style={{ 'fontSize': '0.65rem' }}>District</p>
                        <input style={{ 'resize': 'none' }} type="text" className="box small" autoComplete="off"
                          placeholder="District" onChange={(e) => setApplicantUpdDistrict(e.target.value)}
                          value={updApplicantDistrict} />

                        <p style={{ 'fontSize': '0.65rem' }}>Pin</p>
                        <input style={{ 'fontSize': '1.0rem' }} type="text" className="box small" autoComplete="off"
                          placeholder="Pin" onChange={(e) => setApplicantUpdPin(e.target.value)}
                          value={updApplicantPin} />
                      </div>

                    </div>
                  </div>

                  <button onClick={() => { updateApplicant(id) }} type="button"
                    className="btn solid round">Update</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HealthcardUser;